import React, { useState, useRef, useEffect, useMemo } from 'react';
import './Navbar.css';
import DropdownMenu from './DropdownMenu';
import ProfileMenu from './ProfileMenu';
import { FaRegBell, FaRegUser, FaChevronDown } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo-back-dark.svg';
import { navMenus } from '../../data/navMenus';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
  
  const [activeMenu, setActiveMenu] = useState(null);
  const { logout, ensureMembership } = useAuth();
  const [list, setList] = useState([]);

  // refs separados para los menús
  const marketRef = useRef(null);
  const realestateRef = useRef(null);
  const economicRef = useRef(null);
  const topsuburbsRef = useRef(null);
  const profileRef = useRef(null);

  const menuRefs = useMemo(() => ({
    market: marketRef,
    realestate: realestateRef,
    economic: economicRef,
    topsuburbs: topsuburbsRef,
    profile: profileRef,
  }), [marketRef, realestateRef, economicRef, topsuburbsRef, profileRef]);

  const { user } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = (key) => {
    setActiveMenu((prev) => (prev === key ? null : key));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!activeMenu) return;
      
      const currentRef = menuRefs[activeMenu];
      if (currentRef && currentRef.current && !currentRef.current.contains(e.target)) {
        setActiveMenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [activeMenu, menuRefs]);

  useEffect(() => {
    if (!user || !user.email) {
      setList([]);
      return;
    }

    let mounted = true;

    const fetchMembership = async () => {
      try {
        const res = await ensureMembership(user.email);
        if (!mounted) return;
        setList(res);
      } catch (error) {
        console.error('Error fetching membership data:', error);
      }
    };

    fetchMembership();
    return () => {
      mounted = false;
    };
  }, [user, ensureMembership]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav className="navbar">
      <div className="navbar__logo-wrapper">
        <Link to="/dashboard">
          <img src={logo} alt="INVESCASA" className="navbar__logo-img" />
        </Link>
        <div className="navbar__divider" />
      </div>

      <ul className="navbar__links">
        <li className="navbar__link-item" onClick={() => toggleMenu('market')}>
          <span className={activeMenu === 'market' ? 'active' : ''}>
            Market Cycles
          </span>
          {activeMenu === 'market' && (
            <div ref={marketRef} className="navbar__dropdown-wrapper">
              <DropdownMenu items={navMenus.market} />
            </div>
          )}
        </li>

        <li className="navbar__link-item" onClick={() => toggleMenu('realestate')}>
          <span className={activeMenu === 'realestate' ? 'active' : ''}>
            Real Estate Indicators
          </span>
          {activeMenu === 'realestate' && (
            <div ref={realestateRef} className="navbar__dropdown-wrapper">
              <DropdownMenu items={navMenus.realestate} />
            </div>
          )}
        </li>

        <li className="navbar__link-item" onClick={() => toggleMenu('economic')}>
          <span className={activeMenu === 'economic' ? 'active' : ''}>
            Economic Indicators
          </span>
          {activeMenu === 'economic' && (
            <div ref={economicRef} className="navbar__dropdown-wrapper">
              <DropdownMenu items={navMenus.economic} />
            </div>
          )}
        </li>

        <li className="navbar__link-item" onClick={() => toggleMenu('topsuburbs')}>
          <span className={activeMenu === 'topsuburbs' ? 'active' : ''}>
            Top Suburbs
          </span>
          {activeMenu === 'topsuburbs' && (
            <div ref={topsuburbsRef} className="navbar__dropdown-wrapper">
              <DropdownMenu items={navMenus.topsuburbs} />
            </div>
          )}
        </li>
      </ul>

      <div className="navbar__icons">
        <FaRegBell className="navbar__icon" />
        <div className="navbar__profile-wrapper">
          <button
            className="navbar__profile-btn"
            onClick={() => toggleMenu('profile')}
          >
            <FaRegUser className="navbar__icon" />
            <FaChevronDown
              className={`navbar__arrow navbar__arrow--white ${
                activeMenu === 'profile' ? 'navbar__arrow--open' : ''
              }`}
            />
          </button>
          {activeMenu === 'profile' && (
            <div ref={profileRef} className="navbar__dropdown-wrapper--login">
              <ProfileMenu user={user} member={list} onLogout={handleLogout} />
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
